import React from 'react';
import { useNavigate } from 'react-router-dom';
import UnauthorizedVector from 'assets/vectors/Unauthorized.svg';
import Button from 'components/Button';
import { useAppDispatch } from 'hooks/useStore';
import { clearError } from 'store/error';
import './index.css';

function Unauthorized() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    return (
        <div className='layout unauthorized'>
            <img
                className='unauthorized__image'
                src={UnauthorizedVector}
                alt='Server Error'
            />
            <h1 className='unauthorized__title'>
                Unauthorized
            </h1>
            <p className='unauthorized__text'>
                You don't have permission to access the resource.
            </p>
            <Button
                className='notFound__button'
                onClick={() => {
                    dispatch(clearError());
                    navigate('/');
                }}
            >
                GO BACK
            </Button>
        </div>
    );
}

export default Unauthorized;